import React from 'react';
import { Redirect, Route, Switch } from "react-router-dom";
import Home from '../Home';
import Login from "../Login";
import routes from "../routing";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Wait from "../../shared/Wait";
import PageHeader from "../PageHeader/PageHeader";
import css from "./App.module.scss";
import usePersistedQueryParams from "../../shared/usePersistedAppQueryParams"
import i18next from "i18next";
import usePersistedAppQueryParams from "../../shared/usePersistedAppQueryParams";


const NotLoggedIn = () => {

    const { inProgress } = useMsal();
    if (inProgress !== InteractionStatus.None) {
        // Login in progress
        return (
            <div style={{ height: '100vh' }}>
                <div className="centered"><Wait style={{ padding: '8px 20px' }} /></div>
            </div>
        )
    }

    return (
        <Switch>
            <Route path={routes.login.path} component={Login} />
            <Redirect to={routes.login.path} />
        </Switch>
    );
}

const LoggedIn = () => {
    return (
        <div className={css.home}>
            <div className={css.content}>
                <div className="hcentered">
                    <PageHeader />
                </div>
                <Switch>
                    <Route path={routes.home.path} component={Home} />
                    <Redirect to={routes.home.path} />
                </Switch>
            </div>
            <footer>
                <a href="https://www.carestreamdental.com/en-us/privacy-shield/" target="_blank" rel="noreferrer">GDPR Privacy Shield Policy</a> | <a href="https://www.carestreamdental.com/en-us/privacy-policy" target="_blank" rel="noreferrer">Privacy policy</a>
            </footer>
        </div>
    );
}

const AppRoutes = () => {
    const { lang } = usePersistedAppQueryParams();
    React.useEffect(() => {
        i18next.changeLanguage(lang);
    }, [lang]);

    usePersistedQueryParams();
    return (
        <div style={{ width: '100%', height:"100%", alignItems: 'center'}}>
            <UnauthenticatedTemplate>
                <NotLoggedIn />
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <LoggedIn />
            </AuthenticatedTemplate>
        </div >
    );
}

export default AppRoutes;